import { IconName } from '@blueprintjs/icons';
import React from 'react';
import { FormattedDate } from 'react-intl';
import Box, { BoxProps } from 'ui-box';
import { Icon, defaultFills, minorScale } from '../../npaper';
import {
  PaymentLikelihoodType,
  IPaymentLikelihood,
} from '../../stores/contacts/CompanyStore';

export const PaymentLikelihoodTag = ({
  paymentLikelihood,
  showDate = false,
  ...props
}: {
  paymentLikelihood: IPaymentLikelihood;
  showDate?: boolean;
} & BoxProps<any>) => {
  let icon: IconName = 'tick';
  let color = defaultFills.success[500];
  let text = 'Altid';

  if (paymentLikelihood.type === PaymentLikelihoodType.HIGH) {
    icon = 'arrow-up';
    text = 'Høj';
  } else if (paymentLikelihood.type === PaymentLikelihoodType.MEDIUM) {
    icon = 'dot';
    text = 'Medium';
    color = defaultFills.warning[500];
  } else if (paymentLikelihood.type === PaymentLikelihoodType.LOW) {
    icon = 'arrow-down';
    text = 'Lav';
    color = defaultFills.danger[500];
  }

  return (
    <Box {...props} display="flex" alignItems="center">
      <Icon icon={icon} color={color} marginRight={minorScale(1)} />
      <div className="p">
        {text}
        {showDate && (
          <Box
            className="p muted small"
            marginLeft={minorScale(1)}
            display="inline-block"
          >
            <FormattedDate
              value={paymentLikelihood.updated_at}
              format="default"
            />
          </Box>
        )}
      </div>
    </Box>
  );
};
